import React, { Component } from 'react';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { Input} from '@progress/kendo-react-inputs';
import { DropDownList, ComboBox, MultiSelect } from '@progress/kendo-react-dropdowns';
import axios from 'axios'
import { ROOT_API_URL } from '../../../../../api-config';
import _ from 'lodash';
import './ManageDisctrics.scss';
import { auth } from '../../../../../services/auth.service';
 
class DistrictForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            districtInEdit: this.props.dataItem || null,
            //If on edit, need to store original name of the district
            originalName: this.props.dataItem.description || "",
            value: [],
            counties: [],
            selectedStateId: this.props.dataItem.districtId ? { id: this.props.dataItem.stateId, name: this.props.dataItem.stateName }: { id: 44, name: 'TX', isActive: false },
            selectedCounty: null,
            countyList: this.props.dataItem.countyList || [],
            emailMessage: Object.keys(this.props.dataItem).length == 0 ?"":"User Exists",
            countyErrorMessage: Object.keys(this.props.dataItem).length == 0?"At least one county must be selected":"",
            districtMessage: "",
            countiesMessage: "",
        };
        this.delayedCallback = _.debounce(this.checkEmailCall, 500);
        this.onEmailChange = this.onEmailChange.bind(this);
    };

    componentDidMount() {
        if (Object.keys(this.props.dataItem).length == 0) {//If its on new
            axios
                .get(`${ROOT_API_URL}/ManageDistrict/GetCounties?stateId=${this.state.selectedStateId.id}`, { headers: auth.authHeader() })
                .then((response) => {
                    this.setState({
                        counties: response.data
                    })
                })
                .catch((response) => {
                    console.log(response);
                });
        }
        else {//If its on edit
            let model = {districtId: this.state.districtInEdit.districtId, selectedStateId: this.state.selectedStateId.id}
            axios
                .post(`${ROOT_API_URL}/ManageDistrict/GetCountiesOnEdit`, model, { headers: auth.authHeader() })
                .then((response) => {
                    this.setState({
                        counties: response.data
                    })
                })
                .catch((response) => {
                    console.log(response);
                });
        }
    }

    checkEmailCall() {
        axios
            // .get(`${ROOT_API_URL}/ManageDistrict/CheckAdminUserByEmail?email=${this.state.districtInEdit.assignedLoginId}`, { headers: auth.authHeader() })

            .post(`${ROOT_API_URL}/ManageDistrict/CheckUserByEmail`,
                {
                    email: this.state.districtInEdit.assignedLoginId
                },
                {
                    headers: auth.authHeader()
                }
            )
            .then((response) => {
                this.setState({
                    emailMessage: response.data.message
                })
        })
        .catch((response) => {
            console.log(response);
        });
    }

    onEmailChange(event) {
        let target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.props ? target.props.name : target.name;

        const edited = this.state.districtInEdit;
        edited[name] = value;
        edited.isActive = true;
        this.setState({
            districtInEdit: edited,
            emailMessage: ""
        });

        this.delayedCallback();
    }

    handleSubmit = (event) => {
        event.preventDefault();
        if (this.state.countyList.length > 0) {
            var m = {
                counties: this.state.countyList,
                districtId: this.state.districtInEdit.districtId || 0
            };

            m = m.districtId == 0 ? m.counties : m;

            let path = "/ManageDistrict/AreCountiesAvailableOnSubmit";
            if (this.state.originalName != "") {//If on edit
                path = "/ManageDistrict/AreCountiesAvailableOnSubmitOnEdit";
            }
            axios
                .post(`${ROOT_API_URL + path}`, m, { headers: auth.authHeader() })
                .then((response) => {
                    this.setState({
                        countyErrorMessage: response.data.message
                    })
                    if (this.state.countyErrorMessage == ""
                        && this.state.districtMessage == ""
                        && this.state.emailMessage != "User does not exist. Please create the user." && this.state.emailMessage != "") {
                        this.props.save({
                            ...this.state.districtInEdit,
                            countyList: this.state.countyList,
                            stateName: this.state.selectedStateId.name,
                            stateId: this.state.selectedStateId.id,
                            description: this.state.districtInEdit.description
                        });
                        this.props.cancel();
                    }
                });
        } else {

        }
	}
	isCustom(item) {
		return item.id === undefined;
	}
	addKey(item) {
		item.id = new Date().getTime();
	}
    onDialogInputChange = (event) => {
		let target = event.target;
		const value = target.type === 'checkbox' ? target.checked : target.value;
		const name = target.props ? target.props.name : target.name;

		const edited = this.state.districtInEdit;
		edited[name] = value;
		edited.isActive = true;
		this.setState({
            districtInEdit: edited
		});
    };

    onDistrictChange = (event) => {
        let d = this.state.districtInEdit;
        d.description = event.value;
        this.setState({          
            districtInEdit: d
        });

        if (!parseInt(event.value)) {
            this.setState({
                districtMessage: "Only accept numbers."
            });
        } else if (this.state.originalName == "" || (event.value != this.state.originalName)) {
            axios
                .get(`${ROOT_API_URL}/ManageDistrict/CheckDistrictByName?districtName=${event.value}`, { headers: auth.authHeader() })
                .then((response) => {
                    this.setState({
                        districtMessage: response.data.message
                    })
                })
                .catch((response) => {
                    console.log(response);
                });
        }
        else if ((event.value == this.state.originalName)) {
            this.setState({
                districtMessage: ""
            })
        }
    }

    handleMultiSelectChange = (event) => {
		this.setState({
            selectedCounty: event.target.value,
            countyList: event.target.value.sort((a, b) => (a.countyName > b.countyName) ? 1 : ((b.countyName > a.countyName) ? -1 : 0)),
            countyErrorMessage: event.target.value.length == 0 ? "At least one county must be selected": ""
		})
	};

    handleStateChange = (event) => {
        var selectedState = event.target.value;
        console.log(selectedState);
		this.setState({
            selectedStateId: selectedState,
            selectedCounty: null,
            countyList: [],
            countyErrorMessage: "At least one county must be selected"
		})
        if (this.state.originalName == "") {
            axios
                .get(`${ROOT_API_URL}/ManageDistrict/GetCounties?stateId=${selectedState.id}`, { headers: auth.authHeader() })
                .then((response) => {
                    this.setState({
                        counties: response.data
                    })
                })
                .catch((response) => {
                    console.log(response);
                });
        }
        else {
            let model = {
                SelectedStateId: selectedState.id,
                districtId: this.state.districtInEdit.districtId
            }
            axios
                .post(`${ROOT_API_URL}/ManageDistrict/GetCountiesOnEdit`, model, { headers: auth.authHeader() })
                .then((response) => {
                    this.setState({
                        counties: response.data
                    })
                })
                .catch((response) => {
                    console.log(response);
                });
        }
			
	};
    handleCounty = (event) => {
		this.setState({
            selectedCounty: event.target.value,
            countyList: [...this.state.countyList, event.target.value]
		})
	};

 //   handleAddCounty = (event) => {
	//	event.preventDefault();
 //       this.setState({
 //           countyList: [...this.state.countyList, this.state.selectedCounty],
 //           //counties: 
	//		selectedCounty: null
	//	})
	//};
 //   handleRemoveCounty = (data) => {
	//	this.setState({countyList: this.state.countyList.filter(function(county) { 
 //           return county.countyId !== data
	//		})
	//	});
 //   }


	render() {
		return (
            <Dialog onClose={this.props.cancel}>
                {!this.state.districtInEdit.districtId ?
                    <h2 className="adjust-dist-title">Add New District</h2> : <h2 className="adjust-dist-title">Edit District</h2>
                }
				<form className="user-form" onSubmit={this.handleSubmit}>
					<div className="form-group col-md-6">
                        <label htmlFor="description">District Name</label>
						<Input
							required={true}
							type="text"
							name="description"
							id="description"
							value={this.state.districtInEdit.description || ''}
							onChange={this.onDistrictChange}
                        />
                        <p className="error-message">{this.state.districtMessage}</p>
                    </div>                   
					<div className="form-group col-md-6">
                        <label htmlFor="assignedLoginId">Special Ranger Email</label>
						<Input
							required={true}
							type="text"
							name="assignedLoginId"
							id="assignedLoginId"
							value={this.state.districtInEdit.assignedLoginId || ''}
							onChange={this.onEmailChange}
						/>
                        <p className="error-message">{this.state.emailMessage}</p>
					</div>
					<div className="countiesAddContainer">
						<div className="form-group col-md-6">
                            <label htmlFor="state">State</label>
							<DropDownList data={this.props.states}
								textField="name"
								defaultItem={this.state.selectedStateId}
								dataItemKey="id"
								onChange={this.handleStateChange}
								required={true}
								value={this.id}
								id="state"
								name="state"
							/>
						</div>
                        {/*<div className="form-group col-md-6 col-lg-4">
							<label className="v-spacer"></label>
							<button className="admin-k-button" onClick={this.handleAddCounty}>
								<i className="fas fa-plus-circle"></i>
								<span>Add</span>
							</button>
						</div>*/}
                        <div className="form-group col-lg-6">
                            <label htmlFor="counties">County</label>
                            <MultiSelect
                                data={this.state.counties}
                                onChange={this.handleMultiSelectChange}
                                value={this.state.countyList}
                                textField="countyName"
                                dataItemKey="countyId"
                                allowCustom={true}
                                id="counties"
                                name="counties"
                                className="multiSelection"
                            />
                            <p className="error-message">{this.state.countyErrorMessage}</p>
                            {/* <button className="admin-k-button" onClick={this.handleAddCounty}>Add</button> */}
                        </div>
                    </div>                  				
					<DialogActionsBar>
                        <div className="adjust-sub-btns">
							<div className="form-group">
								<button className="admin-k-button" onClick={this.props.cancel}>
									<i className="fas fa-times"></i>
									<span>CANCEL</span>
								</button>
								{!this.state.districtInEdit.districtId ? (
                                    <button type="submit" className="admin-k-button" >
										<i className="fas fa-save"></i>
										<span>SAVE</span>
									</button>
								) : (
                                        <button type="submit" className="admin-k-button" >
										<i className="fas fa-edit"></i>
										<span>UPDATE</span>
									</button>
								)}
							</div>
						</div>
					</DialogActionsBar>
				</form>
				
			</Dialog>
		);
	}
}

export default DistrictForm;
